import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "../i18n/LanguageContext";

export const MarqueeRibbon = () => {
  const { t } = useLang();
  const words = t.marquee;

  return (
    <div className="border-y border-marigold/30 bg-marigold py-5" data-testid="marquee-ribbon">
      <Marquee speed={40} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="px-8 font-display text-2xl font-medium italic text-purpleink-deep sm:text-3xl">
              {w}
            </span>
            <span className="text-2xl text-purpleink-deep/50">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
